import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export default function useGetPromoPointPoolInfo() {
    const { pointPoolInfos = {} } = useSelector(s => s.pointSystem);

    return useCallback(
        (pointPoolUuid = '') => {
            return pointPoolInfos[pointPoolUuid] || {};
        },
        [pointPoolInfos]
    );
}
